import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'

import { localize, localizeWithVars } from 'helpers/translator/localize'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingOverlaySelector from 'redux/selectors/admin_onboarding/admin_onboarding_overlay_selector'

import styles from './school_free_trial_onboarding_overlay.scss'

class SchoolFreeTrialOnboardingOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlaySchoolUserOnboardingInitialize()
	}

	componentWillUnmount() {
		this.props.actions.overlaySchoolUserOnboardingClose()
	}

	createTitle() {
		return (
			<span styleName='title'>
				<strong styleName='strong'>{localizeWithVars('school_free_trial_overlay_user_title_part1', { days: this.props.durationDays })} </strong><br />
				{localize('school_free_trial_overlay_user_title_part2')}
			</span>
		)
	}

	createAsset(url) {
		return (
			<div styleName='asset'>
				<iframe
					width='100%'
					height='302'
					src={url}
					frameBorder='0'
					allow='encrypted-media'
					allowFullScreen
				></iframe>
			</div>
		)
	}

	render() {

		if (!this.props.durationDays)
			return null

		return (
			<FullOverlay
				headerWithBorder={true}
				title={this.createTitle()}
				assetSource={this.createAsset(localize('school_user_onboarding_admin_video'))}
				primaryTextButton={localize('school_free_trial_overlay_user_primary_button')}
				primaryActionHandler={this.props.actions.overlaySchoolUserOnboardingConfirm}
				secondaryTextButton={localize('school_free_trial_overlay_user_secondary_button')}
				secondaryActionHandler={this.props.actions.overlaySchoolUserOnboardingDismiss}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingOverlaySelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlaySchoolUserOnboardingInitialize: myLibraryActions.overlaySchoolUserOnboardingInitialize,
		overlaySchoolUserOnboardingConfirm: myLibraryActions.overlaySchoolUserOnboardingConfirm,
		overlaySchoolUserOnboardingDismiss: myLibraryActions.overlaySchoolUserOnboardingDismiss,
		overlaySchoolUserOnboardingClose: myLibraryActions.overlaySchoolUserOnboardingClose,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SchoolFreeTrialOnboardingOverlay, styles, {allowMultiple: true}))

export { SchoolFreeTrialOnboardingOverlay }
